module.exports = __webpack_public_path__ + "img/87.91652734.jpg";